import { useSetCustomToken } from '@btime/react-session'
import React from 'react'

import ExecutionFormHandler from './_form/ExecutionFormHandler'
import FormLoader from './_load/FormLoader'
import InviteChecker from './inviteChecker/InviteChecker'
import PageContent from './PageContent'
import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'

const ExecutionPage = ({ shareCode }) => {
  useSetCustomToken('formToken', shareCode)

  return (
    <AbsolutePageTemplate>
      <InviteChecker>
        <FormLoader shareCode={shareCode}>
          <ExecutionFormHandler>
            <PageContent />
          </ExecutionFormHandler>
        </FormLoader>
      </InviteChecker>
    </AbsolutePageTemplate>
  )
}

export default ExecutionPage
